// Generated by purs version 0.13.8
"use strict";
var Data_Argonaut_Decode_Class = require("../Data.Argonaut.Decode.Class/index.js");
var Data_Argonaut_Decode_Generic_Rep = require("../Data.Argonaut.Decode.Generic.Rep/index.js");
var Data_Argonaut_Encode_Class = require("../Data.Argonaut.Encode.Class/index.js");
var Data_Argonaut_Encode_Generic_Rep = require("../Data.Argonaut.Encode.Generic.Rep/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_Generic_Rep = require("../Data.Generic.Rep/index.js");
var Data_Generic_Rep_Show = require("../Data.Generic.Rep.Show/index.js");
var Data_Show = require("../Data.Show/index.js");
var Data_Symbol = require("../Data.Symbol/index.js");
var Settings = (function () {
    function Settings() {

    };
    Settings.value = new Settings();
    return Settings;
})();
var Add = (function () {
    function Add() {

    };
    Add.value = new Add();
    return Add;
})();
var Tree = (function () {
    function Tree() {

    };
    Tree.value = new Tree();
    return Tree;
})();
var Problems = (function () {
    function Problems() {

    };
    Problems.value = new Problems();
    return Problems;
})();
var tabIcon = function (v) {
    if (v instanceof Settings) {
        return "settings";
    };
    if (v instanceof Add) {
        return "add";
    };
    if (v instanceof Tree) {
        return "account_tree";
    };
    if (v instanceof Problems) {
        return "error";
    };
    throw new Error("Failed pattern match at Lunarbox.Data.Tab (line 33, column 11 - line 37, column 22): " + [ v.constructor.name ]);
};
var genericTab = new Data_Generic_Rep.Generic(function (x) {
    if (x instanceof Settings) {
        return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
    };
    if (x instanceof Add) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
    };
    if (x instanceof Tree) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)));
    };
    if (x instanceof Problems) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value)));
    };
    throw new Error("Failed pattern match at Lunarbox.Data.Tab (line 18, column 1 - line 18, column 44): " + [ x.constructor.name ]);
}, function (x) {
    if (x instanceof Data_Generic_Rep.Inl) {
        return Settings.value;
    };
    if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
        return Add.value;
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
        return Tree.value;
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inr)) {
        return Problems.value;
    };
    throw new Error("Failed pattern match at Lunarbox.Data.Tab (line 18, column 1 - line 18, column 44): " + [ x.constructor.name ]);
});
var showTab = new Data_Show.Show(Data_Generic_Rep_Show.genericShow(genericTab)(Data_Generic_Rep_Show.genericShowSum(Data_Generic_Rep_Show.genericShowConstructor(Data_Generic_Rep_Show.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
    return "Settings";
})))(Data_Generic_Rep_Show.genericShowSum(Data_Generic_Rep_Show.genericShowConstructor(Data_Generic_Rep_Show.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
    return "Add";
})))(Data_Generic_Rep_Show.genericShowSum(Data_Generic_Rep_Show.genericShowConstructor(Data_Generic_Rep_Show.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
    return "Tree";
})))(Data_Generic_Rep_Show.genericShowConstructor(Data_Generic_Rep_Show.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
    return "Problems";
})))))));
var eqTab = new Data_Eq.Eq(function (x) {
    return function (y) {
        if (x instanceof Settings && y instanceof Settings) {
            return true;
        };
        if (x instanceof Add && y instanceof Add) {
            return true;
        };
        if (x instanceof Tree && y instanceof Tree) {
            return true;
        };
        if (x instanceof Problems && y instanceof Problems) {
            return true;
        };
        return false;
    };
});
var encodeJsonTab = new Data_Argonaut_Encode_Class.EncodeJson(Data_Argonaut_Encode_Generic_Rep.genericEncodeJson(genericTab)(Data_Argonaut_Encode_Generic_Rep.encodeRepSum(Data_Argonaut_Encode_Generic_Rep.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
    return "Settings";
}))(Data_Argonaut_Encode_Generic_Rep.encodeRepArgsNoArguments))(Data_Argonaut_Encode_Generic_Rep.encodeRepSum(Data_Argonaut_Encode_Generic_Rep.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
    return "Add";
}))(Data_Argonaut_Encode_Generic_Rep.encodeRepArgsNoArguments))(Data_Argonaut_Encode_Generic_Rep.encodeRepSum(Data_Argonaut_Encode_Generic_Rep.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
    return "Tree";
}))(Data_Argonaut_Encode_Generic_Rep.encodeRepArgsNoArguments))(Data_Argonaut_Encode_Generic_Rep.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
    return "Problems";
}))(Data_Argonaut_Encode_Generic_Rep.encodeRepArgsNoArguments))))));
var decodeJsonTab = new Data_Argonaut_Decode_Class.DecodeJson(Data_Argonaut_Decode_Generic_Rep.genericDecodeJson(genericTab)(Data_Argonaut_Decode_Generic_Rep.decodeRepSum(Data_Argonaut_Decode_Generic_Rep.decodeRepConstructorNoArgs(new Data_Symbol.IsSymbol(function () {
    return "Settings";
})))(Data_Argonaut_Decode_Generic_Rep.decodeRepSum(Data_Argonaut_Decode_Generic_Rep.decodeRepConstructorNoArgs(new Data_Symbol.IsSymbol(function () {
    return "Add";
})))(Data_Argonaut_Decode_Generic_Rep.decodeRepSum(Data_Argonaut_Decode_Generic_Rep.decodeRepConstructorNoArgs(new Data_Symbol.IsSymbol(function () {
    return "Tree";
})))(Data_Argonaut_Decode_Generic_Rep.decodeRepConstructorNoArgs(new Data_Symbol.IsSymbol(function () {
    return "Problems";
})))))));
module.exports = {
    Settings: Settings,
    Add: Add,
    Tree: Tree,
    Problems: Problems,
    tabIcon: tabIcon,
    eqTab: eqTab,
    genericTab: genericTab,
    showTab: showTab,
    encodeJsonTab: encodeJsonTab,
    decodeJsonTab: decodeJsonTab
};
